export default ({ theme }) => `
display: flex;
flex-direction: column;
align-items: flex-start;
width: 100%;


  .subscription-container {
    display: flex;
    flex-direction: column;
    max-width:700px;
    align-items: stretch;
    width: 100%;

    .item{
      /* width: 200px; */
      min-width: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      /* padding: 5px; */
      /* box-shadow: 0 0 3px 1px ${theme.borderColor}; */
      margin: 5px 0px;
      border-radius: 8px;
      width: 100%;

      .title-and-limit{
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-items: flex-start;
        min-height: 64px;
        width: 100%;

        .title {
          display: flex;
          justify-content: flex-start;
          text-align: center;
          margin: 10px 0px -5px;
          font-size: 18px;
          color: #495c63;
        }

        .limit {
          text-align: left;
          width: 100%;
          margin: 0px 0px 5px 0px;

          .dropdown-menu {
            /* font-size: 25px; */
            font-weight: bold;
            /* border-color: red; */
          }

          .loading-container {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          }

        }

        .plan-activation {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          font-size: 12px;
          width: 100%;

          .note-and-link {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            font-style: italic;

            .clickable-link {
              cursor: pointer;
              text-decoration: underline;
            }

            .material-icons {
              font-size: 16px;
              padding: 0px 5px;
              cursor: pointer;
            }
          }
        }
      
      }

      .value-prop-container {
        display: flex;
        flex-direction: column;

        .value-prop {
          margin: 10px 0px 10px -20px;
          background: ${theme.alternateAccentColor};
          padding: 5px 10px;
          font-weight: bolder;
          font-size: 18px;
          text-transform: uppercase;
          color: #000;
          text-align: left;
          width: fit-content;
        }

      }

    }
    
    .selection-bar{
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;

      .selection-and-amount {
        display: flex;
        flex-direction: column;

        .selection-name {
          font-size: 16px;
          font-weight: bold;

          @media (max-width: 600px) {
            font-size: 10px;
          }
        }

        .selection-amount {
          display: flex;
          /* font-size: 14px; */
        }
      }

      .selection-activate-plan {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        padding: 0 20px 0 0;

        .active-plan {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 4px 8px;
          border-radius: 5px;
          background: ${theme.alternateAccentColor};
          color: #000;
          font-size: 11px;
          font-weight: 800;
          font-style: normal;
          letter-spacing: 0.4px;
          white-space: nowrap;

          @media (max-width: 600px) {
            font-size: 8px;
            padding: 2px 5px;
          }
        }
      }


    }


  p {
    font-size: 20px;
  }

 }
`;
